import { toggleButtonState, validateForm } from './validate-form.js';
import { resetErrors } from './handle-error.js';
import {
	emailRequest,
} from './requests.js';

/**
 * free email check
 * if the email field ends in any of the predefined free email domains,
 * show additional fields and make them required
 */
export const setupFreeEmailCheck = () => {
	const handler = (event) => {
		const { value } = event.target;
		const isFree = (value.match(/(@gmail\.com|@yahoo\.com)$/) !== null);
		const additionalInfo = document.querySelector('.personal-info');
		const additionalFields = additionalInfo.querySelectorAll('input[type]:not([type="hidden"]),select');

		additionalInfo.inert = !isFree;

		additionalFields.forEach((field) => {
			field.required = isFree;
		})
	};
	const emailFields = document.querySelectorAll('input[type="email"]');
	const eventTypes = [
		'keyup',
		'blur',
	];

	emailFields.forEach((emailField) => {
		eventTypes.forEach((type) => {
			emailField.addEventListener(type, handler);
		});
	});
};





/**
 * validate email input on blur, using Product API
 */
export const setupEmailValidation = () => {
	const emailField = document.querySelectorAll('input[name="Email"]');

	/**
	 * on blur, validate email
	 */
	const handleBlur = (event) => {
		const el = event.target;
		const form = el.closest('form');
		const { value } = el;
		const valid = el.checkValidity();
		const validated = el.classList.contains('slf__email-validated');
		const body = {
			'email': value,
		}

		if (value !== '' && valid && validated === false) {
			resetErrors();
			el.classList.add('slf__email-validating');
			toggleButtonState(form, false);
			emailRequest(body).then(() => {
				form.dataset.extValid = 'pass';
			}).catch((e) => {
				form.dataset.extValid = 'fail';
			}).finally(() => {
				el.classList.toggle('slf__email-validated', (form.dataset.extValid === 'pass'));
				el.classList.remove('slf__email-validating');
				validateForm(form);
			});
		}
	};

	/**
	 * disable submit button on key up
	 * if the field has changed, it needs to be revalidated
	 * and if they enter a valid email, unlock the submit button
	 * then change the email, there is a second or two where
	 * the button is clickable. not a vulnerability, but
	 * moreso UX polish
	 */

	function debounce(func, delay) {
		let timeoutId;

		return function () {
			const context = this;
			const args = arguments;

			this.classList.remove('slf__email-validated');
			this.closest('form').dataset.extValid = 'fail';

			clearTimeout(timeoutId);

			timeoutId = setTimeout(() => {
				func.apply(context, args);
			}, delay);
		};
	}

	// Example usage:
	const handleKeyup = debounce((context, args) => {
		handleBlur(context);
	}, 350);


	emailField.forEach(field => {
		field.addEventListener('blur', handleBlur);
		field.addEventListener('keyup', handleKeyup);
	})
};
